import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// Define custom props interface that includes Grid props plus the 'item' prop
interface CustomGridProps {
  item?: boolean;
  xs?: boolean | number;
  sm?: boolean | number;
  md?: boolean | number;
  lg?: boolean | number;
  xl?: boolean | number;
  container?: boolean;
  spacing?: number;
  alignItems?: string;
  justifyContent?: string;
  sx?: any;
  children?: React.ReactNode;
  [key: string]: any; // Allow for any other props
}

// This component fixes compatibility with MUI v7 Grid
// It converts the old item prop pattern to the new API
const Grid: React.FC<CustomGridProps> = (props) => {
  const { item, ...otherProps } = props;
  
  // In MUI v7, we don't need the 'item' prop, as it's determined by the presence of xs, sm, etc.
  return <MuiGrid {...otherProps} />;
};

export default Grid;
